// Corregir voz de un CLIP del Estudio — `/v1/videos/corregir-voz-clip/start` y `/status`
// del atlas-backend. Mismo par start/status que el borrado (`videoErase.ts`), pero sin
// fallback a n8n: esta capacidad nació directamente en el backend propio y nunca existió
// como webhook. Gratis: el backend no mira el saldo.
//
// Start `{response:'success', jobId}`; status `{status:'done'|'processing'|'error',
// storagePath?, error?, error_type?}`. `storagePath` es relativo a `video-project-assets`
// y termina en `.mp4` (el clip tenía video) o `.m4a` (era audio solo).

import { atlasBackendFetch } from './atlasBackend';
import type { EdicionLab, PalabraLab } from '../components/corregirVoz/transcript';

export type CorregirVozClipStartBody = {
  video_url: string;
  project_id: string;
  palabras: PalabraLab[];
  ediciones: EdicionLab[];
  modo_utilizado?: string;
};

/** Devuelve el Response CRUDO — el caller maneja status y body, como con el borrado. */
export async function postCorregirVozClipStart(body: CorregirVozClipStartBody): Promise<Response> {
  return atlasBackendFetch('/v1/videos/corregir-voz-clip/start', body, {
    signal: AbortSignal.timeout(60_000),
  });
}

export async function postCorregirVozClipStatus(body: { job_id: string }): Promise<Response> {
  return atlasBackendFetch('/v1/videos/corregir-voz-clip/status', body, {
    signal: AbortSignal.timeout(60_000),
  });
}
